import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import loadable from '@loadable/component';
import { COUNTRY_SHORT_NAME } from '@commons/constants';
import Spinner from '@components/Spinner';

function getPath(countryCode) {
  const {
    CHILE,
    ARGENTINA,
    BOLIVIA,
    PARAGUAY,
    PANAMA,
    URUGUAY,
    COLOMBIA,
    DOMINICANAN_REPUBLIC,
    ECUADOR,
    PERU,
    COSTA_RICA,
    EL_SALVADOR,
    VENEZUELA,
    GUATEMALA,
    HONDURAS,
  } = COUNTRY_SHORT_NAME;

  switch (countryCode) {
    case ARGENTINA:
      return './types/ArgentinaCardForm';
    case CHILE:
      return './types/ChileCardForm';
    case BOLIVIA:
    case PARAGUAY:
    case PANAMA:
    case URUGUAY:
    case COLOMBIA:
    case DOMINICANAN_REPUBLIC:
    case ECUADOR:
    case PERU:
    case COSTA_RICA:
    case EL_SALVADOR:
    case VENEZUELA:
    case GUATEMALA:
    case HONDURAS:
      return './types/GenericCardForm';
    default:
      throw new Error();
  }
}

const Lazy = path =>
  loadable(() => import(`${path}`), {
    fallback: <Spinner />,
  });

function CardForm({ countryCode, ...props }) {
  const T = useMemo(() => {
    const path = getPath(countryCode);
    return Lazy(path);
  }, [countryCode]);

  return <T {...props} />;
}

CardForm.propTypes = {
  // redux
  countryCode: PropTypes.string.isRequired,
  // calling component
  intl: intlShape,
};

// export default CardForm;
export default injectIntl(CardForm);
